import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  dialog: css`
    z-index: 1000;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  `,
  content: css`
    width: 660px;
    display: flex;
    flex-direction: column;
    padding: 16px 0;
    min-width: 520px;
    max-height: 90vh;
    min-height: 0;
    overflow: hidden;

    & > button:first-of-type {
      width: 20px;
      height: 20px;

      & svg {
        width: 16px;
        height: 16px;
      }
    }
  `,
  header: ({ theme }) => css`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    border-bottom: 1px solid ${theme.colors.neutral.variant[20]};
    && {
      padding: 0 24px 16px;
    }
  `,
  headerDescription: css`
    display: flex;
    text-align: center;
  `,
  body: css`
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 24px;
  `,
  list: css`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  `,
  rowDivider: ({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.neutral.variant[20]};
  `,
  row: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border-radius: 14px;
  `,
  rowLeft: css`
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    flex: 1;
  `,
  iconContainer: css`
    display: flex;
    align-items: flex-start;
    padding: 8px;
    border-radius: 7px;
    flex-shrink: 0;
  `,
  candidateName: css`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  retryButton: css`
    display: flex;
    align-items: flex-start;
    padding: 8px;
    border-radius: 7px;
    flex-shrink: 0;
    cursor: pointer;
  `,
  sessionLinkButton: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 7px;
    flex-shrink: 0;
    cursor: pointer;
  `,
  successIcon: css`
    padding: 6px;
  `,
} satisfies Styles<{}>;

export const useStyles = withStyles(styles);
